const RecoveryPasswordWrapper = ({ children }) => {
  return (
    <div className="pt-24 px-4 sm:max-w-[360px] w-full m-auto">{children}</div>
  );
};

export default RecoveryPasswordWrapper;
